// pages/im/components/reconcile-panel/reconcile-panel.js
import { IMEventBus } from "lib/mp-stjk-im-service";

Component({
    /**
     * 组件的属性列表
     */
    properties: {},

    /**
     * 组件的初始数据
     */
    data: {
        interactiveMode: 0
    },
    ready: function() {
        const controlPanel = this.selectComponent(".control-panel");
        // 如果展示控制面板 则优先展示控制面板 否则展示消息发送面板
        IMEventBus.addListener("emit_panel_msg", (emitType, ...params) => {
            console.log('interactiveMode-->emitType',emitType);
            console.log('interactiveMode-->params',params);
            const { showLeadEnd, showReNew } = controlPanel.data;
            if (emitType === "robot_emitter" && (showLeadEnd || showReNew))
                return;
            IMEventBus.trigger(emitType, ...params);
        });
        // 关闭调和面板
        IMEventBus.addListener("CLOSE_RECONCILE", () => {
            IMEventBus.trigger("input_emitter", false);
            IMEventBus.trigger("robot_emitter", false);
            IMEventBus.trigger("control-emitter", false);
        });
    },

    /**
     * 组件的方法列表
     */
    methods: {}
});
